<script>
// Accumulation/Distribution Line indicator

import { Overlay } from '../../'
import { drawIndicatorPlot } from '../../workspace/indicator-plots.mjs'

export default {
    name: 'ADL',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'TradingCandle', version: '1.0.0',
                desc: 'Accumulation/Distribution Line',
                preset: {
                    name: 'ADL',
                    side: 'offchart',
                    settings: {
                        lineWidth: 1.5,
                        color: '#2196f3'
                    }
                }
            }
        },
        draw(ctx) {
            drawIndicatorPlot(ctx, this.$props.data, this.$props.layout, this.sett, 0, {color:this.color,width:this.line_width})
        },
        use_for() { return ['ADL'] },
        legend(values) {
            return [{
                value: values[1] ? values[1].toFixed(0) : '0',
                color: this.color
            }]
        },
        calc() {
            return {
                props: {},
                update: `
                    let multiplier = high[0] === low[0] ? 0 : (2 * close[0] - high[0] - low[0]) / (high[0] - low[0])
                    return [cum(ts(multiplier * vol[0]))[0]]
                `
            }
        }
    },
    computed: {
        sett() { return this.$props.settings },
        line_width() { return this.sett.lineWidth || 1.5 },
        color() { return this.sett.color || '#2196f3' }
    }
}
</script>
